module.exports=function(e){var t={};function o(i){if(t[i])return t[i].exports;var n=t[i]={i:i,l:!1,exports:{}};return e[i].call(n.exports,n,n.exports,o),n.l=!0,n.exports}return o.m=e,o.c=t,o.d=function(e,t,i){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(o.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)o.d(i,n,function(t){return e[t]}.bind(null,n));return i},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=42)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},42:function(e,t,o){"use strict";var i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const n=i(o(1)),r=i(o(2)),a=o(3),{KineduPalette:l}=a.colorPalettes,u=r.default.div`
  position: relative;
  top: 0px;
  width: 100%;
  max-width: 425px;
  max-width: ${({maxWidth:e})=>"number"==typeof e?e+"px":e};
  margin: ${({gap:e})=>e}px;
  border-radius: 6px;
  box-shadow: 0px 4px 30px -12px ${l.shadeDark};

  color: #fff;
  background-image: ${({image:e})=>e?`url(${e})`:""};
  background-size: cover;
  background-position: ${({bgPosition:e})=>e};

  ${({show:e})=>a.globalStyles.fade(e,.4)}
  transition: all 0.4s ease-in-out;

  cursor: pointer;
  overflow: hidden;
  user-select: none;

  :hover {
    top: -2px;
    box-shadow: 0px 22px 80px -30px ${l.shadeDark};
    :after {
      animation: shine 1.5s ease 0s 1 normal none running;
    }
  }

  ${a.breakPoints.tablet} {
    width: ${({width:e})=>Number.isInteger(e)?e+"px":e};
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    transition: all 0.5s ease-in-out;
    background: linear-gradient(311deg, transparent 30%, rgb(255, 255, 255, 0.2), transparent 70%) 0% 0% / 300% 300%;

    @keyframes shine {
      0%  {background-position:0% 50%; opacity: 0;}
      20% {opacity: 1;}
      50% {background-position:100% 50%;}
      70% {opacity: 0;}
      100% {background-position:100% 50%; opacity: 0;}
    }
  }
`,s=r.default.div`
  position: relative;
  width: 100%;
  height: 0;
  padding: 0;
  padding-bottom: ${({heightRatio:e})=>e}%;

  ${a.breakPoints.tablet} {
    padding-bottom: ${({mdHeightRatio:e})=>e}%;
  }
`,d=r.default.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  ${({innerStyle:e})=>e};
`,p=({children:e=null,className:t="",image:o="",onClick:i,style:r,innerStyle:a,width:l=280,maxWidth:p=425,heightRatio:c=85,mdHeightRatio:f=85,bgPosition:g="",gap:h=10,show:b})=>n.default.createElement(u,{image:o,className:t,onClick:i,style:r,width:l,maxWidth:p,bgPosition:g,gap:h,show:b},n.default.createElement(s,{heightRatio:c,mdHeightRatio:f},n.default.createElement(d,{innerStyle:a},e)));p.defaultProps={},t.default=p}});